import { Swiper } from './swiper-dK1UiadY.js';
import { A as A11y } from './a11y-DLppOU3x.js';
import { A as Autoplay } from './autoplay-BEB4pTqf.js';
import './utils-Djv5ZeLF.js';

class HeroBanner extends HTMLElement {
  #swiper = this.querySelector('.swiper');
  #animationId = null;

  connectedCallback() {
    const autoplayDelay = Number(this.dataset.autoplayDelay) || 3000;
    const autoplayEnabled = this.dataset.autoplayEnabled === 'true';

    this.addEventListener('click', (e) => {
      if (e.target.closest('.swiper-prev')) this.#swiper.swiper.slidePrev();
      if (e.target.closest('.swiper-next')) this.#swiper.swiper.slideNext();
    });

    new Swiper(this.#swiper, {
      modules: [A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: autoplayEnabled && {
        delay: autoplayDelay,
        disableOnInteraction: false,
      },
      on: {
        activeIndexChange: () => this.#animateProgressBar(autoplayDelay),
      },
    });
  }

  #animateProgressBar(duration) {
    if (this.#animationId) cancelAnimationFrame(this.#animationId);

    const bars = this.querySelectorAll('[data-swiper-progress]');
    bars.forEach((b) => (b.style.width = '0%'));

    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      bars.forEach((b) => (b.style.width = `${progress * 100}%`));
      if (progress < 1) this.#animationId = requestAnimationFrame(animate);
    };

    this.#animationId = requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    if (this.#animationId) cancelAnimationFrame(this.#animationId);
    this.#swiper.swiper?.destroy();
  }
}

customElements.define('hero-banner', HeroBanner);
